var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleWhole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336.014 128C304.013 128 256.011 144 224.022 160C192.009 144 144.008 128.006 112.007 128.004C32.004 128 0.413 210.459 0.003 288C-0.528 387.975 63.997 512 160.001 512C192.002 512 208.002 496 224.003 496C240.003 496 256.004 512 288.005 512C384.008 512 448.408 389.164 447.998 288C447.689 211.578 416.017 128 336.014 128ZM320.013 32V0H288.012C243.831 0 208.01 35.816 208.01 80V112H240.011C284.196 112 320.013 76.184 320.013 32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleWhole);
export default __webpack_public_path__ + "static/media/apple-whole.4ed7eb50fc9b13920850c97dd0b077c2.svg";
export { ForwardRef as ReactComponent };